import { Flex, Text, Link } from '@chakra-ui/react'
import React from 'react'
import { AiFillGithub } from 'react-icons/ai'

const Footer = () => {
  return (
    <div className="sm:flex sm:items-center sm:justify-between w-[95%] mx-auto py-5">
    <a href="https://ebpto.com/" className="flex items-center">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-[40px] w-auto relative text-black"
        viewBox="0 0 970 339"
      >
        <g fill="none" fillRule="evenodd">
          <path
            fill="#000"
            d="M344.9 232.4c17.3 0 27.7-6 31.2-17.9 3.5-11.9 5.2-25 5.2-39.2v-1c0-14-1.8-26.7-5.4-38.3-3.6-11.6-14-17.3-31-17.3-15.2 0-24.9 4.9-29.1 14.8-4.2 9.9-6.6 20.7-7 32.5v18c.5 12 2.8 23.1 6.9 33.2 4.1 10.2 13.8 15.2 29.2 15.2z"
          />
          <path
            fill="#000"
            d="M525.5 232.4c17.1 0 27.4-5.8 31-17.3 3.6-11.6 5.4-24.3 5.4-38.3v-1c0-14.2-1.8-27.3-5.2-39.2-3.5-11.9-13.9-17.9-31.2-17.9-15.4 0-25.1 5.1-29.2 15.2-4.1 10.1-6.4 21.2-6.9 33.2v18c.5 11.8 2.8 22.6 7 32.5 4.2 9.9 13.9 14.8 29.1 14.8z"
          />
          <path
            fill="#000"
            fillRule="nonzero"
            d="M933 .5H678.2v83.6h26.7v28.2h-26.7v106.5c0 5.1 1 8.6 3.1 10.6 2 2 5.4 3.1 9.9 3.1h13.7v34.7h-19.1c-12.8 0-23.3-3.9-31.8-11.7-8.4-7.8-12.6-19-12.6-33.4V112.2H623V84h18.4V.4H308.8v103.1c7-6.5 14.3-11.7 21.8-15.7 7.6-4 16.1-6 25.5-6 11.3 0 21 2.2 29.1 6.7 8.1 4.5 14.7 10.2 20 17.1.2.2.4.5.5.7.1.2.3.4.5.4 4.6 6.5 7.7 14.1 9.4 22.9 1.7 8.8 2.5 24 2.5 45.7 0 21.9-.8 37.3-2.5 46.2-1.7 8.9-4.8 16.5-9.4 22.7-.2 0-.4.1-.5.4-.1.2-.3.5-.5.7-5.3 6.7-12 12.3-20 16.8-8.1 4.5-17.8 6.7-29.1 6.7-9.4 0-18.2-1.9-26.4-5.8-8.2-3.8-15.2-8.9-20.9-15.2v19.1H272V.5H37C16.8.5.4 16.9.4 37.1v265.2c0 20.2 16.4 36.6 36.6 36.6h415.6V84.1h36.8v19.1c5.8-6.3 12.8-11.4 20.9-15.3 8.2-4 17-6 26.4-6 11.3 0 21 2.2 29.1 6.7 8.1 4.5 14.7 10.2 20 17.1.2.2.4.5.5.7.1.2.3.4.5.4 4.6 6.3 7.7 13.8 9.4 22.7 1.7 8.9 2.5 24.3 2.5 46.2 0 21.7-.8 36.9-2.5 45.7-1.7 8.8-4.8 16.4-9.4 22.9-.2 0-.4.1-.5.4-.1.2-.3.5-.5.7-5.3 6.7-12 12.3-20 16.8-8.1 4.5-17.8 6.7-29.1 6.7-9.4 0-17.9-1.9-25.5-5.8-7.6-3.8-14.9-9-21.8-15.5v91.2H933c20.2 0 36.6-16.4 36.6-36.6V37.1C969.6 16.9 953.2.5 933 .5zm-698.9 189H120c0 14.9 4.2 26.2 12.5 33.8 8.3 7.6 18.7 11.4 31.2 11.4 1.4 0 2.9-.1 4.3-.2s2.9-.3 4.3-.5c5.5-1 11.1-2.9 16.6-5.8 5.5-2.9 10.5-6.6 14.8-11.2l26.7 22.7c-8.9 10.4-19.1 17.8-30.5 22.4-11.4 4.6-23.3 6.9-35.6 6.9-2.4 0-4.8-.1-7-.2-2.3-.1-4.6-.3-7-.5-16.8-2.2-32.3-9.8-46.2-22.9-14-13.1-20.9-36.2-20.9-69.1 0-31.8 6.7-54.7 20-68.8 13.4-14.1 28.1-22.3 44.2-24.7 1.9-.2 3.8-.4 5.6-.5 1.8-.1 3.7-.2 5.6-.2 20.2 0 37.8 7 52.9 20.9 15 14 22.6 32.7 22.6 56.3v30.2zm648.2 29.6c-3 9.6-7.9 18.3-14.6 26l-.7.7c-.5.5-.9 1-1.3 1.4-.4.5-.8 1-1.3 1.4-5.3 5.1-12.2 9.7-20.8 13.9-8.5 4.2-19.3 6.3-32.3 6.3-13 0-23.8-2.1-32.3-6.3-8.5-4.2-15.5-8.8-20.8-13.9-.5-.5-.9-1-1.3-1.4-.4-.5-.8-1-1.3-1.4l-.7-.7c-6.7-7.7-11.6-16.4-14.6-26-3-9.6-4.5-24.2-4.5-43.7 0-19.5 1.5-34 4.5-43.5s7.9-18.1 14.6-25.8l.7-.7c.5-.5.9-1 1.3-1.4.4-.5.8-1 1.3-1.4 5.3-5.1 12.2-9.7 20.8-14.1 8.5-4.3 19.3-6.5 32.3-6.5 13 0 23.8 2.2 32.3 6.5 8.5 4.3 15.5 9 20.8 14.1.5.5.9 1 1.3 1.4.4.5.8 1 1.3 1.4l.7.7c6.7 7.7 11.6 16.3 14.6 25.8s4.5 24 4.5 43.5-1.5 34.1-4.5 43.7z"
          />
          <path
            fill="#000"
            d="M158.7 116.5c-10.8 0-19.9 3.6-27.1 10.8-7.2 7.2-11.1 17.8-11.6 31.8h77.3c-.5-14-4.3-24.5-11.6-31.8-7.2-7.1-16.2-10.8-27-10.8z"
          />
          <path
            fill="#000"
            d="M843.1 135.3c-.2-.5-.5-1-.9-1.6-.4-.6-.8-1.1-1.3-1.6-2.7-3.8-6.7-7-12.1-9.6-5.4-2.5-11.3-3.8-17.5-3.8-6.3 0-12.1 1.3-17.5 3.8s-9.4 5.7-12.1 9.6c-.5.5-.9 1-1.3 1.6-.4.6-.7 1.1-.9 1.6-2.6 4.3-4.5 9.2-5.4 14.6-1 5.4-1.4 13.9-1.4 25.5 0 11.8.5 20.4 1.4 25.8 1 5.4 2.8 10.3 5.4 14.6.2.5.5 1 .9 1.6.4.6.8 1.1 1.3 1.6 2.6 3.9 6.7 7 12.1 9.6 5.4 2.5 11.2 3.8 17.5 3.8 6.3 0 12.1-1.3 17.5-3.8s9.4-5.7 12.1-9.6c.5-.5.9-1 1.3-1.6.4-.6.7-1.1.9-1.6 2.6-4.3 4.4-9.2 5.4-14.6s1.4-13.9 1.4-25.5c0-11.8-.5-20.4-1.4-25.8-.9-5.4-2.7-10.2-5.4-14.6z"
          />
        </g>
      </svg>
    </a>
    <div className="flex mt-4 space-x-6 sm:justify-center sm:mt-0">
      <a
        href="https://twitter.com/ownyourip"
        className="text-zinc-100 hover:text-gray-900 dark:hover:text-white"
      >
        <svg
          className="w-10 h-10 text-zinc-300"
          fill="currentColor"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
        </svg>
        <span className="sr-only">Twitter page</span>
      </a>
      <a
        href="#"
        className="text-zinc-100 hover:text-gray-900 dark:hover:text-white"
      >
        <svg
          className="w-10 h-10 text-zinc-300"
          fill="currentColor"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path
            fillRule="evenodd"
            d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z"
            clipRule="evenodd"
          />
        </svg>
        <span className="sr-only">GitHub account</span>
      </a>
      <a
        href="https://etherscan.io/address/0xEB668b89be0C33d1A1559305d75F91e0a54e69Ab"
        className="text-zinc-100 hover:text-gray-900 dark:hover:text-white"
      >
        <img
          alt=""
          className="w-9 h-9 saturate-0 opacity-20"
          src="https://ebpto.com/etherscan-logo-circle.svg"
        />
        <span className="sr-only">Etherscan Contract</span>
      </a>
    </div>
  </div>
  
  )
}

export default Footer
